import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as tPromise from "io-ts-promise";
import {
  setWebBookerLanguageReqT,
  webBookerSettingsT,
} from "dora-contracts";
import { createErrorReportingAsyncThunk } from "../../helpers";
import { LanguageType } from "../../../i18n";
import { apiFetch } from "../../../helpers/api-fetch";

const prefix = "app/web-booker-settings";

type State = {
  loaded: boolean;
  language: LanguageType;
};

const initialState: State = {
  loaded: false,
  language: "da",
};

export const loadSettings = createErrorReportingAsyncThunk(
  `${prefix}/load`,
  async () => {
    const result = await apiFetch("/web-booking-api/settings");
    if (!result.ok) {
      throw new Error("Error loading settings");
    }
    return result.json().then(tPromise.decode(webBookerSettingsT));
  }
);

export const setLanguage = createErrorReportingAsyncThunk(
  `${prefix}/set-language`,
  async (value: LanguageType, { dispatch, getState }) => {
    const previousValue = getState().app.webBookerSettings.language;
    dispatch(slice.actions.setLanguage(value));
    const result = await apiFetch("/web-booking-api/settings/language", {
      method: "PUT",
      body: JSON.stringify(setWebBookerLanguageReqT.encode({ value })),
      headers: { "Content-Type": "application/json" },
    });
    if (!result.ok) {
      dispatch(slice.actions.setLanguage(previousValue));
      throw new Error("Error updating setting");
    }
  }
);

const slice = createSlice({
  initialState,
  name: prefix,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageType>) => {
      state.language = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadSettings.fulfilled, (state, action) => {
      state.loaded = true;
      state.language = action.payload.language;
    });
  },
});

export default slice.reducer;
